import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GeneralInfoService } from 'src/app/services/ha-new/general-info.service';

@Component({
	selector: 'app-digital-banner',
	templateUrl: './digital-banner.component.html',
	styleUrls: ['./digital-banner.component.scss'],
})
export class DigitalBannerComponent implements OnInit, OnDestroy {
	pulseDigitalEligibility: boolean = false;
	/** Data carrier subscriptions */
	subscriptions: Subscription;
	constructor(private generalInfoService: GeneralInfoService) {}

	digitalBannerImagePath = Object.freeze({
		bannerBackgroundImage: '../../../../../assets/images/BR_202204_PulseDigital_myehe_banners_QR_RD01.png',
		playStoreQRcodeImage: '../../../../../assets/images/qr-code_GooglePlay.svg',
		appStoreQRcodeImage: '../../../../../assets/images/qr-code-Apple.svg',
	});

	ngOnInit() {
		this.subscriptions = this.generalInfoService.getPulseDigitalEligiblity().subscribe(data => {
			this.pulseDigitalEligibility = data.isEligible;
		});
	}
	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}
}
